import { Component } from '@theme/component';

/** Owns the homepage's native footer disclosures across section updates. */
class MitoqHomeFooter extends Component {
  #query;
  #controller;

  connectedCallback() {
    super.connectedCallback();
    this.#cleanup();
    this.#query = matchMedia('(max-width: 768px)');
    this.#controller = new AbortController();
    this.#query.addEventListener('change', this.#apply);
    this.addEventListener('click', this.#handleClick, { signal: this.#controller.signal });
    this.#apply();
  }

  updatedCallback() {
    super.updatedCallback();
    this.#apply();
  }

  disconnectedCallback() {
    this.#cleanup();
    super.disconnectedCallback();
  }

  #cleanup() {
    this.#query?.removeEventListener('change', this.#apply);
    this.#controller?.abort();
    this.#query = undefined;
    this.#controller = undefined;
  }

  #apply = () => {
    if (!this.#query) return;
    for (const group of this.querySelectorAll('[data-footer-group]')) {
      group.open = !this.#query.matches;
      const summary = group.querySelector('summary');
      if (summary) summary.tabIndex = this.#query.matches ? 0 : -1;
    }
    const footer = this.querySelector('[data-home-footer]');
    if (footer) footer.dataset.initialized = 'true';
  };

  #handleClick = (event) => {
    const summary = event.target instanceof Element ? event.target.closest('[data-footer-group] summary') : null;
    if (!this.#query?.matches && summary && this.contains(summary)) event.preventDefault();
  };
}

if (!customElements.get('mitoq-home-footer')) customElements.define('mitoq-home-footer', MitoqHomeFooter);
